import { Box, Button, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { Loader, ModalWrapper } from 'src/components'

import { useStyles } from '../styles'
import { IScanToEarnCreateAccountOrProductDto, IScanToEarnSettingsConfirmModal } from 'src/types'

interface IProps {
  open: boolean
  handleClose: () => void
  handleConfirm: (data: IScanToEarnCreateAccountOrProductDto) => Promise<void>
  data: IScanToEarnSettingsConfirmModal | null
  isLoading: boolean
}

export const ScanToEarnConfirmSettingsModal = ({
  open,
  handleClose,
  handleConfirm,
  data,
  isLoading,
}: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  if (!data) {
    return
  }

  return (
    <ModalWrapper
      open={open}
      onClose={() => {
        if (!isLoading) {
          handleClose()
        }
      }}
      className={classes.settingsModal}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          gap: '8px',
          alignItems: 'start',
        }}
      >
        <Typography
          fontWeight={500}
          sx={{
            fontSize: '18px',
            textAlign: 'center',
            color: theme.palette.custom.darkBlue2,
            mb: '20px',
            mt: '5px',
            mx: '3px',
          }}
        >
          Are you sure you want to create the following entities?
        </Typography>

        {data?.accountName && (
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{
              color: theme.palette.custom.darkBlue2,
            }}
          >
            Account: <span style={{ fontWeight: 400, marginLeft: '6px' }}>{data.accountName}</span>
          </Typography>
        )}

        {data?.productName && (
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{
              color: theme.palette.custom.darkBlue2,
            }}
          >
            Product: <span style={{ fontWeight: 400, marginLeft: '6px' }}>{data.productName}</span>
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          textAlign: 'center',
          justifyContent: 'center',
          pt: '10px',
          gap: '18px',
        }}
      >
        <Button onClick={handleClose} variant="outlined" size="small" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleConfirm({
              create_account: data.createAccount,
              create_product: data.createProduct,
              consumer_scan_id: data.consumerScanId,
              selected_account_id: data.selectedAccountId,
            })
          }}
          variant="contained"
          size="small"
          disabled={isLoading}
        >
          <Typography sx={{ mr: isLoading ? '8px' : 0 }}>Confirm</Typography>
          {isLoading && <Loader isStatic size={18} />}
        </Button>
      </Box>
    </ModalWrapper>
  )
}
